export enum ApplicationNotificationEventType {
  ACTIVATED,
  CANCELLED,
  EXPIRED,
  FILLED,
  MODIFIED,
  SUSPENDED,
  ENTERED,
  PART_FILLED,
}

export namespace ApplicationNotificationEventType {
  let elements = [
    ApplicationNotificationEventType.ACTIVATED,
    ApplicationNotificationEventType.CANCELLED,
    ApplicationNotificationEventType.EXPIRED,
    ApplicationNotificationEventType.FILLED,
    ApplicationNotificationEventType.MODIFIED,
    ApplicationNotificationEventType.SUSPENDED,
    ApplicationNotificationEventType.ENTERED,
    ApplicationNotificationEventType.PART_FILLED,
  ];
  let alias = "com.bcdfx.model.ApplicationNotificationEventType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
